<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>宝箱道具配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table
          :data="formData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
          >
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" placeholder="宝箱ID" />
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="宝箱名称"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" style="width: 150px;" placeholder="宝箱名称" />
            </template>
          </el-table-column>
          <el-table-column
            prop="skinResourceId"
            label="皮肤资源ID"
          >
            <template v-slot:default="scope">
              <el-input v-model="scope.row.skinResourceId" placeholder="皮肤资源ID" />
            </template>
          </el-table-column>
          <el-table-column label="奖励">
            <template v-slot:default="scope">
              <Reward v-model="scope.row.reward" />
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:chestProp:add']" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:chestProp:save']" size="mini" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getChestPropCfgList, updateChestPropCfg } from '@/api/config/chest-prop-cfg'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import Reward from '@/components/Reward'
export default {
  name: 'ChestProp',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      langVisibleArr: [{ visible: false }],
      weightVisibleArr: [{ visible: false }],
      starProVisibleArr: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 100
      },
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      formData: [
        {
          'id': 0,
          'name': '',
          'skinResourceId': 0,
          'reward': []
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.name === '') {
          this.msgError('宝箱名称不能为空')
          return false
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateChestPropCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.$store.dispatch('app/clearLocalStorage', { key: 'getChestPropCfgAll' })
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getChestPropCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        propsId: 0,
        name: '',
        skinResourceId: 0,
        reward: []
      })
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse; /* 合并边框 */
}

td {
  border: 1px solid #ccc; /* 单元格边框样式 */
  padding: 5px; /* 单元格内边距 */
  height: 30px;
  width: 100px;
  text-align: center;
}
</style>
